import script from "./DetailedReports.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedReports.vue?vue&type=script&setup=true&lang=js"

import "./DetailedReports.vue?vue&type=style&index=0&id=6e8faa7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8faa7d"]])

export default __exports__